import * as React from 'react';
import { AuthenticatedImage } from "./AuthenticatedImage.jsx";
import {
    Box,
    styled,
    FormControlLabel,
    Checkbox,
    TextField,
    FormHelperText,
    Tooltip,
    Paper,
    Button,
    ButtonGroup,
    ToggleButton,
    Grid,
    createTheme,
    ThemeProvider,
    Icon,
    IconButton,
    Stack,
    Divider,
    Typography,
    InputLabel,
    FormControl,
    MenuItem,
    Select,
    ToggleButtonGroup
} from "@mui/material";
import theme from './x2bim_theme.jsx'
//import $ from "jquery"
import {getBaseUrl, getBlobBaseUrl, mapContainerPosition} from "./../utils/utils.js";
import {useDispatch, useSelector} from 'react-redux';
import {updateUserFavorite} from '../store/features/app/appActions.js';
import LegacyProcessViewer from './legacyProcessPopup.jsx';
import LegacyProcessMap from './legacyProcessMap.jsx';
import LegacyProcessPopup from './legacyProcessPopup.jsx';
import {Link} from 'react-router-dom';
import {t} from "i18next";
import { useDispatchAndSave } from '../hooks/useDispatchAndSave.js';


function Greybar(props) {
    return (
        <Paper className={props.className} onScroll={props.onScroll}
               elevation={props.elevation == undefined ? 10 : props.elevation} sx={{
            zIndex: 2,
            p: 1.5, ...props.sx,
            pointerEvents: "auto",
            typography: theme.typography.regular,
            color: theme.palette.white.main,
            backgroundColor: "#282D37DF",
            borderRadius: 0,
        }}>
            {props.children}
        </Paper>

        /*
            <Box sx={{...props.sx, , position: "fixed"}}>
            <Paper sx={{m: 2, p: 1.5,typography: theme.typography.regular,color: theme.palette.white.main, backgroundColor: "#38342F99", borderRadius: 0}}>{props.children}</Paper>
            </Box>
        */
    )
}

function X2BIMIconButton(props) {
    return (
        <Button size="small" sx={{...props.sx, p: 1}} onClick={props.onClick} href={props.href}>
            <Stack direction="row" justifyContent={props.justifyContent || "flex-start"} sx={{width: "100%"}}
                   alignItems="center">
                <SVGIcon height="25px" path={props.path}/>
                <Box sx={{ml: 1, color: theme.palette.primary.main}}>{props.children}</Box>
            </Stack>
        </Button>)
}

function X2BIMCheckbox(props) {
    return (
        <FormControlLabel control={
            <Checkbox sx={{"&, &.MuiCheckbox-root": {color: "#FFFFFF"},}} checked={props.checked}
                      onChange={props.onChange}/>
        } label={props.label}/>
    )
}


function ViewSyncButtonGroup(props) {
    return <ToggleButtonGroup fullWidth size="small" color="info" value={props.synccomponents} onChange={props.handlesynccomponentchange} >
                <X2BIMToggleButton value={"all"} tooltip={props.t("v.ic.syncall")} bright sx={{ backgroundColor: props.synccomponents.length ? '#787878' : undefined }}>
                    <SVGIcon path={`/public/assets/gyroscope_${props.synccomponents.includes("all") ? "black" : "white"}.png`} />
                </X2BIMToggleButton>
                <X2BIMToggleButton value={"translation"} tooltip={props.t("v.ic.synctransl")} bright>
                    <SVGIcon path={`/public/assets/movement_${props.synccomponents.includes("translation") ? "black" : "white"}.png`} />
                </X2BIMToggleButton>
                <X2BIMToggleButton value={"rotation"} tooltip={props.t("v.ic.syncrot")} bright>
                    <SVGIcon path={`/public/assets/rotation_${props.synccomponents.includes("rotation") ? "black" : "white"}.png`} />
                </X2BIMToggleButton>
                <X2BIMToggleButton value={"zoom"} tooltip={props.t("v.ic.synczoom")} bright>
                    <SVGIcon path={`/public/assets/zoom_${props.synccomponents.includes("zoom") ? "black" : "white"}.png`} />
                </X2BIMToggleButton>
           </ToggleButtonGroup>}

function X2BIMDropdownHeader(props) {

    const [infoExpanded, setInfoExpanded] = React.useState(false)

    const {enableCompare, compareMenu} = props

    return (
        <React.Fragment>
            <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center" sx={{pr: 1}}>
                {props.children}
                {!compareMenu && <>
                    {/* <SVGIconButton tooltip={props.t("v.mb.expand_settings")} sx={{ border: props.settingsExpanded ? 1 : null }} onClick={() => { props.setSettingsExpanded(!props.settingsExpanded) }} height="25px" path={props.settingsExpanded?"/public/assets/ic-db_navigation_expand-less_20.svg":"/public/assets/ic-db_navigation_expand-more_20.svg"} /> */}
                    <SVGIconButton sx={{ border: 3, borderColor: infoExpanded ? "white" : "transparent" }}
                                   height="25px"
                                   path="/public/assets/Info 24dp.svg"
                                   onClick={() => setInfoExpanded(!infoExpanded)} />
                    <SVGIconButton tooltip={props.t("v.dd.pin_dropdown")}
                                   sx={{ border: 3, borderColor: props.dropdown_pinned ? "white" : "transparent" }}
                                   height="25px"
                                   path="/public/assets/Pin 20dp.svg"
                                   onClick={() => props.pinDropdown(!props.dropdown_pinned)}/>
                </>}
                {/* <Typography sx={{ py: 2, typography: theme.typography.h1, fontSize: 20 }} align="right">{props.t(`v.mb.${props.type}_long`)}</Typography> */}
            </Stack>
            {/* Use setInnerHtml here to enable html tags in "_help" translations */}
            {infoExpanded && <InfoBox>
                <div dangerouslySetInnerHTML={{__html: props.t(`v.mb.${props.type}_help`)}}/>
            </InfoBox>}
        </React.Fragment>
    )
}

function X2BIMDivider(props) {
    if (props.orientation == "vertical") {
        return <Divider {...props} orientation="vertical" sx={{bgcolor: "#DDDDDDAA"}} variant="middle" flexItem/>
    } else {
        return <Divider {...props} sx={{
            "&::before, &::after": {
                borderColor: "#FFFFFF",
            },
        }}>
            {props.children}
        </Divider>
    }
}

function X2BIMSelect(props) {
    return <FormControl variant="standard" sx={{
        width: 190,
        input: {color: '#FFFFFF'},
        "& .MuiFormLabel-root": {
            color: 'primary.main'
        },
        "& .MuiFormLabel-root.Mui-focused": {
            color: 'secondary.main'
        },
        "& .MuiInputBase-root": {
            color: 'primary.main'
        }
    }}>
        <InputLabel id="demo-simple-select-standard-label">{props.label}</InputLabel>
        <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={props.defaultValue}
            onChange={props.onChange}
            label={props.label}
            renderValue={props.renderValue ? props.renderValue : undefined}
            
        >
            {props.customRenderValues ? props.customRenderValues :props.values.map((val) => <MenuItem key={val} value={val}>{val}</MenuItem>)}
        </Select>
    </FormControl>
}

function X2BIMToggleButton(props) {

    const WhiteHoverToggleButton = styled(ToggleButton)({
        "&.Mui-selected, &.Mui-selected:hover": {
            color: props.bright ? "black" : "white",
            backgroundColor: props.bright ? '#ffffff' : '#787878'
        }
    });

    if (!props.tooltip) return <WhiteHoverToggleButton {...props} sx={{ borderColor: "rgba(245, 244, 241, 0.5)", color: "#ffffff", ...props.sx }}>{props.children}</WhiteHoverToggleButton>

    return (
        <Tooltip placement={props.tooltipplacement} title={<div style={{ whiteSpace: 'pre-line' }}>{props.tooltip}</div>}>
            <WhiteHoverToggleButton {...props} sx={{ borderColor: "rgba(245, 244, 241, 0.5)", color: "#ffffff", ...props.sx }}>{props.children}</WhiteHoverToggleButton>
        </Tooltip>
    )
}


function LoadingPopup(props) {
    return (
        <ThemeProvider theme={theme}>
            <Box sx={{
                ...props.sx,
                typography: theme.typography.h1,
                zIndex: 2,
                position: "fixed",
                top: "40%",
                left: "45%",
            }}>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    {props.text || props.t("v.loading")}
                    <img height="60px" className={"rotationloop"}
                         src="/public/assets/ic-db_ticket_komfort-check-in-circle_32.svg"/>

                </Grid>
            </Box>
        </ThemeProvider>
    )
}

const index2roman = {0: "I", 1: "II", 2: "III", 3: "IV"}
const index2letter = {0: "A", 1: "B", 2: "C", 3: "D"}
const type2descriptor = {"OPENLAYERS": "MAP", "POTREE": "3D", "INSPECT": "INSP", "PROFILE": "PRF", "VIDEO": "VID"}
const containerTypeLabel = (containertype) => {
    let text = ""
    if (containertype == "OPENLAYERS") {
        text = "2D"
    }
    if (containertype == "POTREE") {
        text = "3D"
    }
    return text
}
const containerlabel = (container, prefix, width) => {
    const {typeindex, type} = container
    return <Box
        sx={{typography: theme.typography.h1, width: width || 45, textAlign: "center", whiteSpace: "nowrap"}}>
        {/*{(prefix || "") + "  " + `${["OPENLAYERS","POTREE"].includes(containertype) ? index2letter[index] : ""}`}<sub>{containerTypeLabel(containertype)}</sub>*/}
        {(prefix || "") + " " + type2descriptor[type]}{(typeindex != undefined) && <sub>{typeindex + 1}</sub>}
    </Box>
}

// function ImagePopup(feature) {
//     //var image_url = getBaseUrl() + "/blob/" + feature.feature.processId + "/input/" + feature.feature.name + ".jpg";
//     var image_url = "https://staging.x2bim.com" + "/blob/" + feature.feature.processId + "/input/" + feature.feature.name + ".jpg";

//     //console.log("SHOWING IMAGE", image_url)

//     return (
//         <div>
//           {/* <button onClick={toggleModal}>Open Image</button> */}
//             <div >
//                 <div >
//                     {/* <span className="close" onClick={toggleModal}>&times;</span> */}
//                     <img style={{ width: "8%" }} src={image_url} alt="Scaled down" />
//                 </div>
//             </div>
//         </div>
//     );
// }

function InfoContainer(props) {

    const left = props.placement == "left" ? "3%" : "None"
    const right = props.placement == "right" ? "3%" : "None"
    const ref = React.useRef(null);
    const [bottom, setBottom] = React.useState("3%")
    const hasTopContent = Boolean(props.children || props.visibleWhenCollapsed)

    React.useEffect(() => {
        const handleResize = () => {
            if (!ref || !ref.current) {
                return
            }
            const br = ref.current.getBoundingClientRect()
            // console.log(`${window.innerWidth / 2 - 315} < ${br.x.toFixed()} < ${window.innerWidth / 2 + 230} | ${window.innerHeight - 250} < ${br.y.toFixed()}`)
            if ((br.x > window.innerWidth / 2 - 315) && (br.x + 70 < window.innerWidth / 2 + 300) && (window.innerHeight - br.y < 250)) {
                console.log("OVERLAP")
                setBottom('calc(3vh + 50px)')
            } else {
                setBottom("3%")
            }
        }
        window.addEventListener('resize', handleResize)
    })

    if (props.rotation != undefined) {
        var rotate = 'rotate(' + props.rotation + 'deg)';
        const elment = document.querySelector(`#compass${props.index}`)
        if (elment) {
            elment.style["transform"] = rotate
            elment.style["-webkit-transform"] = rotate
            elment.style["-moz-transform"] = rotate
            elment.style["-ms-transform"] = rotate
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <Stack className='menus' direction="column" spacing={1} sx={{
                maxWidth: props.maxWidth || 250,
                bottom: bottom,
                left: left,
                right: right,
                position: "absolute"
            }}>

                {(props.rotation != undefined) &&
                    <Stack direction="row" justifyContent="center" sx={{zIndex: 2, px: 1.5, cursor: "pointer"}}
                           onClick={props.setToNorth}>
                        <img height="30px" id={`compass${props.index}`} data-rotate="30"
                             className="my-auto ml-2 pointer" src="/public/assets/ic-db_maps_gps-north_32.svg"
                             alt="My_Logo"/>
                    </Stack>}

                {hasTopContent && (props.visibleWhenCollapsed || (props.expanded || props.collapseDisabled) && !props.expandDisabled) &&
                    <Greybar>
                        <Stack spacing={1} sx={{justifyContent: "space-between"}}>
                            {(props.expanded || props.collapseDisabled) ? props.children : props.visibleWhenCollapsed}
                        </Stack>
                    </Greybar>}

                <Greybar sx={{py: 0, pl: 0, pr: 0.5}}>
                    <Stack ref={ref} sx={{height: 41, width: props.headerRight ? "100%" : "auto"}} direction="row" justifyContent={props.headerRight ? "space-between" : "center"} alignItems="center"
                           spacing={-1}> {/* spacing={props.expanded ? 1 : 0}*/}
                        {!props.collapseDisabled && !props.expandDisabled &&
                            (props.expanded
                                    ? <SVGIconButton tooltip={props.t("v.ic.collapse")} onClick={() => {
                                        props.setExpanded(false)
                                    }} height="25px" path="/public/assets/ic-db_navigation_expand-more_20.svg"/>
                                    : <SVGIconButton tooltip={props.t("v.ic.expand")} onClick={() => {
                                        props.setExpanded(true)
                                    }} height="25px" path="/public/assets/ic-db_navigation_expand-less_20.svg"/>
                            )}
                        {props.label || ""}

                        {props.color && <Box sx={{width: 18}}></Box>}
                        {props.color &&
                            <Box sx={{width: 24, height: 24, backgroundColor: props.color, borderRadius: '4px'}}></Box>}
                        {(props.color || props.loading) && <Box sx={{width: 12}}></Box>}
                        {props.loading && <img height="36px" className="rotationloop"
                                               src="/public/assets/ic-db_ticket_komfort-check-in-circle_32.svg"/>}
                        {props.headerRight && <Box sx={{display: "flex", alignItems: "center", ml: 2}}>{props.headerRight}</Box>}
                    </Stack>
                </Greybar>
            </Stack>
        </ThemeProvider>
    )
}

function InfoBox(props) {
    return (
        <Box sx={{m: 2, p: 1, border: 1}} elevation={1}>{props.children}</Box>
    )
}

const darkTheme = createTheme({palette: {mode: 'dark',},});

function SVGIconButton(props) {
    return (
        <ThemeProvider theme={darkTheme}>
            <Tooltip placement="top" title={props.disabled ? "" : props.tooltip} arrow>
                <IconButton {...props} sx={{ ml: 1, ...props.sx }}>
                    <Icon sx={{
                        height: props.height ? props.height : "25px",
                        width: props.height ? props.height : "25px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>

                        {props.icon ? props.icon :
                            <img src={props.path} height={props.height ? props.height : "25px"}/>
                        }
                    </Icon>
                    {props.children}
                </IconButton>
            </Tooltip>
        </ThemeProvider>
    )
}

function SVGIcon(props) {
    return (
        <Box {...props} component="img" sx={{height: props.height ? props.height : "25px", ...props.sx}}
             src={props.path ?? props.src}/>
    )
}

export function ProjectFavorite({projectId, sx = {}}) {
    const dispatchAndSave = useDispatchAndSave()
    const {userConfig} = useSelector((state) => state.app)
    const isFav = userConfig && userConfig.favoriteProjects?.includes(projectId)
    const toggleFavorite = (projectId) => {
        dispatchAndSave(updateUserFavorite(projectId))
    }
    return <SVGIconButton onClick={(e) => {
        e.stopPropagation();
        toggleFavorite(projectId)
    }} sx={{...sx, color: "white"}}
                          path={`/public/images/svg_icons/${isFav ? "pin_solid.svg" : "pin.svg"}`}></SVGIconButton>
}


export default function ProjectImage({projectId, width, height}) {

    return (<AuthenticatedImage
        src={`${getBlobBaseUrl()}/blob/afa00c76-92ed-4998-8995-4f8fe53b2633/logo.png`}
        onError={({currentTarget}) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = "/public/images/placeholder.png";
        }}
    />)
}

const X2BIMTextField = (props) =>
    <FormControl fullWidth={props.fullWidth && true} sx={{
        ...props.sx,
        input: {color: '#FFFFFF'},
        "& .MuiFormLabel-root": {
            color: 'primary.main'
        },
        "& .MuiFormLabel-root.Mui-focused": {
            color: 'secondary.main'
        },
        "& .MuiInputBase-root": {
            color: 'primary.main'
        },
        "& .MuiFormHelperText-root": {
            color: 'primary.main'
        },
    }}>
        <TextField {...props} id="standard-basic" variant={props.variant || "standard"} autoComplete='off'/>
        {props.helptext && <FormHelperText id="component-error-text">{props.helptext}</FormHelperText>}
    </FormControl>


const get_process_extent = (process) => [process.minx, process.miny, process.maxx, process.maxy]
const get_process_group_extent = (group) => group.map(g => get_process_extent(g)).reduce(([minx_global, miny_global, maxx_global, maxy_global], [minx_local, miny_local, maxx_local, maxy_local]) => [Math.min(minx_global, minx_local), Math.min(miny_global, miny_local), Math.max(maxx_global, maxx_local), Math.max(maxy_global, maxy_local)], [1e10, 1e10, null, null])
const get_button_text = (cont, showtype) => ((cont == undefined || cont.ref.current == undefined) ? "" : cont.ref.current.getPositionDescription(showtype))
const timespan2days = (start, end) => start ? Math.floor((end - start) / 8.64e+7) + 1 : 0


const useContainerPosition = (containers) => {

    const [position, setPosition] = React.useState({})
    React.useEffect(() => {
            const mapContainer = containers.filter(c => c.type == "OPENLAYERS").find(() => true) // first occurance
            if (mapContainer) {
                setPosition(mapContainerPosition(mapContainer))
            }

            const handleWindowResize = () => {
                setPosition(mapContainerPosition(mapContainer));
            };

            window.addEventListener('resize', handleWindowResize);

            return () => {
                window.removeEventListener('resize', handleWindowResize);
            };

        },
        [containers.length]
    )

    return position
}

const AddRemoveButton = (props) => {

    const {cont, rendered_in_cont, group, full_active, half_active} = props

    const checkActiveInViewer = (layer) => pids_in_group.includes(layer.id) && (!props.menuSide || layer[props.menuSide])

    const pids_in_group = group ? group.map(x => x.processId) : []
    const active_in_viewer = rendered_in_cont ? rendered_in_cont.filter(checkActiveInViewer) : []
    const full_display = (full_active != undefined) ? full_active : (pids_in_group.length == active_in_viewer.length)
    const half_display = (half_active != undefined) ? half_active : (active_in_viewer.length && pids_in_group.length >= active_in_viewer.length)
    const [loaded, setLoaded] = React.useState(false)
    const [disabled, setDisabled] = React.useState(props.disabled)

    const button_variant = () => (!disabled && half_display) ? "contained" : "outlined"
    const button_color = () => (half_display && !full_display) ? "grey" : "primary"

    // Async loading logic (for large panorma loadings, mostly)
    const [data] = active_in_viewer
    const loadingpromise = (data && data.loadingpromise) ? data.loadingpromise : false
    React.useEffect(() => {
        if (loadingpromise && typeof (loadingpromise) == "object") {
            setLoaded(undefined)
            // console.log("BUTTON loading...")
            loadingpromise.then(res => {
                // console.log("BUTTON LOADED.", res)
                setLoaded(res)
                setDisabled(!res)
            })
        }
    }, [loadingpromise]);

    // Handler for Main button click
    const buttonclickhandler = () => {
        full_display ? props.remove(cont, props.group, props.menuSide) : props.add(cont, props.group, props.type, props.menuSide);
        props.render()
    }

    // LEGACY processes
    if (props.group && props.group[0].legacy && props.type == "ortho") {
        return <LegacyProcessPopup data={props.group[0]}/>
        // return <Button component={Link} variant="outlined" target='_blank' to={`/oldviewer/${props.group[0].processId}`}>{props.t("v.process.external_viewer")}</Button>

        // AKTUELL
    } else {
        const label = containerlabel(cont, full_display ? "-" : "+")
        return (
            <ButtonGroup variant="outlined" disabled={disabled}>

                {!props.disableExtentBtn && <Button sx={{width: 40}} onClick={() => {
                    if (["pointcloud", "glb", "panorama"].includes(props.type)) {
                        cont.ref.current.fitExtent(props.group)
                    } else {
                        cont.ref.current.fitExtent(props.group.length > 1 ? get_process_group_extent(props.group) : get_process_extent(props.group[0]), props.group[0].epsgId)
                    }
                }}>
                    {(loaded != undefined) ? <SVGIcon path="/public/assets/ic-db_navigation_fullscreen_32.svg"/> :
                        <Box component="img" height="30px" className={"rotationloop"}
                             src="/public/assets/ic-db_ticket_komfort-check-in-circle_32.svg"/>}

                </Button>}

                <Button color={button_color()} variant={button_variant()} sx={{ml: 1}} key={cont.id}
                        onClick={buttonclickhandler}>{label}</Button>

            </ButtonGroup>)
    }
}

export {
    Greybar,
    X2BIMIconButton,
    X2BIMToggleButton,
    X2BIMCheckbox,
    ViewSyncButtonGroup,
    AddRemoveButton,
    InfoBox,
    containerlabel,
    X2BIMDropdownHeader,
    X2BIMSelect,
    SVGIconButton,
    SVGIcon,
    InfoContainer,
    X2BIMTextField,
    LoadingPopup,
    get_button_text,
    get_process_group_extent,
    timespan2days,
    get_process_extent,
    X2BIMDivider,
    useContainerPosition
}